import React from 'react'
import { makeStyles } from "@material-ui/core/styles";
import Copyright from '../copyrights'

const UseStyles = makeStyles((theme) => ({
  footer: {
    marginTop: "auto",
    backgroundColor: theme.palette.primary.main,
    color: "white",
    padding: theme.spacing(2),
    "& .footerLogo": { filter: "invert(1)" },
  },
}));
const appFooter = () => {
    const classes = UseStyles();
    return (
    <footer className={classes.footer}>
        <Copyright />
    </footer>
    )
}

export default appFooter
